import { addToJobQueue, clearJobQueue } from "slices/app/appSlice";
import localhost from "apis/localhost";
import { showErrorModal } from "slices/app/actions/error";
import { elements, modalTypes } from "constants/types";
import { hideModal } from "slices/app/actions/modals";
import { pollJobStatus } from "slices/discovery/actions/theme";
import {
  setByContentData,
  setByContentPage,
  setLoading,
} from "slices/discovery/discoverySlice";
import { saveToLS } from "@visiblethread/react-components/dist/utils";
import { DISCOVERY_SHRED_TO_EXCEL_LS_KEY } from "constants/discovery";

// TODO: VT-5713 - Remove this once we move the loading of byContent data to streams
// Abort controllers are only valid per request
export const getAllByContentDataAbortController = {
  controller: false,
};

export const addIndexesByContentData = (data) =>
  data.map((item, index) => ({ ...item, index: index + 1 }));

export const getAllByContentData = () => async (dispatch, getState) => {
  dispatch(setLoading({ element: elements.BY_CONTENT_VIEW, loading: true }));
  getAllByContentDataAbortController.controller = new AbortController();

  await localhost
    .get("/docs/discovery/byContent/termInstances", {
      signal: getAllByContentDataAbortController.controller.signal,
      params: {
        folderId: getState().discovery.config.folderId,
        docId: getState().discovery.config.documentId,
      },
    })
    .then(async (response) => {
      const { data } = response;
      dispatch(setByContentData(addIndexesByContentData(data)));
    })
    .catch((error) => {
      if (error.code !== "ERR_CANCELED") dispatch(showErrorModal(error));
    })
    .finally(() => {
      dispatch(
        setLoading({ element: elements.BY_CONTENT_VIEW, loading: false })
      );
    });
};

export const getByContentData = (limit) => async (dispatch, getState) => {
  dispatch(addToJobQueue("genericJob"));

  const params = {
    folderId: getState().discovery.config.folderId,
    docId: getState().discovery.config.documentId,
    limit,
  };

  await localhost
    .get("/docs/discovery/byContent/termInstancesWithLimit", {
      params,
    })
    .then(async (response) => {
      const { data } = response;
      dispatch(setByContentData(addIndexesByContentData(data)));
      if (data.length === limit) dispatch(getAllByContentData());
    })
    .catch((error) => {
      dispatch(showErrorModal(error));
    })
    .finally(() => {
      dispatch(clearJobQueue());
    });
};

export const shredToExcel =
  (documentsWithTerms, shredOptionsRequest) => async (dispatch, getState) => {
    dispatch(addToJobQueue("genericJob"));

    const { folderId } = getState().discovery.config;
    const documentView = folderId !== undefined;
    const url = `/docs/discovery/export/${documentView ? "document" : "folder"}/shred`;

    await localhost
      .post(url, { folderId, documentsWithTerms, shredOptionsRequest })
      .then(async (response) => {
        dispatch(hideModal(modalTypes.SHRED_TO_EXCEL));
        const jobData = response.data.jobId;
        dispatch(pollJobStatus(jobData));
        dispatch(addToJobQueue("genericJob"));
        saveToLS(
          DISCOVERY_SHRED_TO_EXCEL_LS_KEY,
          JSON.stringify(shredOptionsRequest)
        );
      })
      .catch((error) => {
        dispatch(showErrorModal(error));
        dispatch(clearJobQueue());
      });
  };

export const clearByContentData = () => async (dispatch) => {
  dispatch(setByContentPage(1));
  dispatch(setByContentData([]));
};
